import { AxiosResponse } from "axios";
import { MunicipioDTO, UfDTO } from "../interface/Localidade";
import api from "../api/api";

export const localidadeService = {
    getMunicipios: async (nome: string): Promise<AxiosResponse<MunicipioDTO[]>> => {
        return api.get(`/localidade/municipios`, {
            params: {
                nome: nome
            }
        });
    },

    getUfs: async (): Promise<AxiosResponse<UfDTO[]>> => {
        return api.get(`/localidade/ufs`);
    }
}